import styled from "styled-components";
import { popularProducts } from "../data";
import NewProItem from './NewProItem'


const Container = styled.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;


const NewProduct = () => {
  return (
    <Container>
      {popularProducts.map((item) => (
        <NewProItem item={item} key={item.id} />
      ))}
    </Container>
  );
};

export default NewProduct;